import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { Observable, map, take, filter, of, catchError, timeout } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(): Observable<boolean> {
    // console.log('AdminGuard - Iniciando validación...');
    
    return this.authService.currentUser$.pipe(
      // Esperar hasta que el estado de autenticación sea definitivo (no 'undefined')
      filter(user => user !== undefined),
      take(1), // Tomar el primer valor definitivo y cancelar la suscripción
      map(currentUser => {
        // console.log('AdminGuard - Usuario final para validación:', currentUser);
        
        if (!currentUser) {
          // console.log('AdminGuard - No hay usuario autenticado, redirigiendo a login');
          this.router.navigate(['/login']);
          return false;
        }
        
        const isAdmin = currentUser.role === 'admin';
        // console.log('AdminGuard - ¿Es admin?:', isAdmin);
        
        if (!isAdmin) {
          // console.log('AdminGuard - Acceso denegado: usuario no es administrador');
          this.authService.logout();
          return false;
        }

        // Validar si tiene acceso al dominio actual
        try {
          const hasAccess = this.authService.isAccessAllowedForCurrentDomain(currentUser.role);
          if (!hasAccess) {
            // console.log('AdminGuard - Acceso denegado por dominio');
            this.authService.logout();
            return false;
          }
        } catch (error) {
          // console.error('AdminGuard - Error validando acceso:', error);
          this.authService.logout();
          return false;
        }
        
        // console.log('AdminGuard - Acceso permitido para:', currentUser.name);
        return true;
      }),
      timeout(15000), // Timeout de 15 segundos por si algo sale mal
      catchError(error => {
        // console.error('AdminGuard - Error o timeout. Redirigiendo a login.', error);
        this.router.navigate(['/login']);
        return of(false);
      })
    );
  }
}
